(function () {
  'use strict';
  if (window.__pbGuaranteeInitialized) return;
  var dialog = document.getElementById('pb-guarantee-notice');
  var configNode = document.getElementById('pb-guarantee-language-config');
  if (!dialog || !configNode || typeof dialog.showModal !== 'function') return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  window.__pbGuaranteeInitialized = true;
  var opener = null;
  var suppressEscapeKeyup = false;
  function currentLanguage() {
    if (window.pbDraftLanguage) { var draftCode = window.pbDraftLanguage(); if (config[draftCode]) return draftCode; }
    var nativeWidget = document.querySelector('.weglot_switcher.country-selector [role="combobox"][data-l]');
    var code = nativeWidget ? nativeWidget.getAttribute('data-l') : document.documentElement.lang;
    code = String(code || '').toLowerCase().split('-')[0];
    return Object.prototype.hasOwnProperty.call(config, code) ? code : dialog.dataset.pbGuaranteeDefaultLanguage;
  }
  function syncLinks() {
    var language = currentLanguage();
    var labels = config[language];
    if (!labels) return;
    document.querySelectorAll('[data-pb-guarantee-open]').forEach(function (link) {
      if (link.dataset.pbGuaranteeLanguage === language) return;
      link.dataset.pbGuaranteeLanguage = language;
      link.textContent = labels.title;
      link.href = labels.asset;
      link.lang = language;
    });
  }
  function prepareNotice(language) {
    if (dialog.dataset.pbGuaranteeLanguage === language) return;
    var template = document.getElementById('pb-guarantee-language-' + language);
    if (!template || !config[language]) return;
    dialog.replaceChildren(template.content.cloneNode(true));
    dialog.dataset.pbGuaranteeLanguage = language;
    dialog.lang = language;
  }
  function resetNoticeZoom() {
    var image = dialog.querySelector('.pb-guarantee__imagewrap');
    var button = dialog.querySelector('[data-pb-guarantee-enlarge]');
    if (image) { image.dataset.pbGuaranteeEnlarged = 'false'; image.scrollLeft = 0; image.scrollTop = 0; }
    if (button) { button.setAttribute('aria-pressed', 'false'); var labels = config[dialog.dataset.pbGuaranteeLanguage]; if (labels) button.textContent = labels.enlarge; }
    dialog.scrollLeft = 0; dialog.scrollTop = 0;
  }
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest('[data-pb-guarantee-open]');
    if (!link) return;
    syncLinks();
    if (dialog.open) { event.preventDefault(); return; }
    opener = link;
    try {
      prepareNotice(currentLanguage());
      resetNoticeZoom();
      dialog.showModal();
      link.setAttribute('aria-expanded', 'true');
      event.preventDefault();
    } catch (error) { opener = null; }
  });
  dialog.addEventListener('click', function (event) {
    // An open modal must not click through to the theme's window-level drawer closer.
    event.stopPropagation();
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    if (target.closest('[data-pb-guarantee-close]')) { dialog.close(); return; }
    var enlarge = target.closest('[data-pb-guarantee-enlarge]');
    if (!enlarge) return;
    var image = dialog.querySelector('.pb-guarantee__imagewrap');
    if (!image) return;
    var expanded = enlarge.getAttribute('aria-pressed') !== 'true';
    enlarge.setAttribute('aria-pressed', String(expanded));
    image.dataset.pbGuaranteeEnlarged = String(expanded);
    var labels = config[dialog.dataset.pbGuaranteeLanguage];
    enlarge.textContent = expanded ? labels.fit : labels.enlarge;
  });
  dialog.addEventListener('focusin', function (event) { if (dialog.open) event.stopPropagation(); });
  ['keydown', 'keyup'].forEach(function (type) {
    dialog.addEventListener(type, function (event) {
      if (dialog.open && (event.key === 'Escape' || event.key === 'Tab')) event.stopPropagation();
    });
  });
  document.addEventListener('keyup', function (event) {
    if (suppressEscapeKeyup && event.key === 'Escape') { suppressEscapeKeyup = false; event.stopPropagation(); }
  }, true);
  dialog.addEventListener('cancel', function (event) { suppressEscapeKeyup = true; event.stopPropagation(); resetNoticeZoom(); });
  dialog.addEventListener('close', function () {
    resetNoticeZoom();
    queueMicrotask(function () { if (!dialog.open) resetNoticeZoom(); });
    requestAnimationFrame(function () { if (!dialog.open) resetNoticeZoom(); });
    var previousOpener = opener;
    opener = null;
    if (previousOpener) previousOpener.setAttribute('aria-expanded', 'false');
    if (previousOpener && previousOpener.isConnected) previousOpener.focus({ preventScroll: true });
  });
  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(syncLinks);
    observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['lang', 'data-l'] });
  }
  window.addEventListener('load', syncLinks);
  syncLinks();
})();

